import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Reg from "../../images/reg.png";
import Loading from "../../images/loading.gif";
import { backendApi } from "../../api/apiService";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function Register() {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState(location.state.email);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isloading, setIsloading] = useState(false);

  const Signup = () => {
    if (name.trim() === "") {
      toast.warn("Please enter your Name", { containerId: "D" });
      return false;
    } else if (mobile.trim() === "") {
      toast.warn("Please enter your Mobile Number", { containerId: "D" });
      return false;
    } else if (password.trim() === "") {
      toast.warn("Please set a Password for your account", {
        containerId: "D",
      });
      return false;
    }
    setIsloading(true);
    var req = {
      functionName: "candidateSignup",
      fullname: name,
      mobile: mobile,
      email_id: email,
      password: password,
      is_active: 1,
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          toast.success(
            "Organization Registered succesfully.Please check your email for OTP",
            { containerId: "D" }
          );
          localStorage.setItem("candidateId", response.candidateId);
          navigate("/otp", {
            state: {
              candidateId: response.candidateId,
              email:email
            },
          });
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  return (
    <div className="xilliCrm bg-login">
      <ToastContainer
        enableMultiContainer
        containerId={"D"}
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <div className="main-wraps active col-lg-10 p-3" id="container">
        <div className="row">
          <div className="col-lg-5">
            <div className="xiAddOrg">
              <img
                src={Reg}
                alt="Reg"
                className="img-fluid regImg"
                width="450"
                height="450"
              />
            </div>
          </div>
          <div className="col-lg-7 px-md-5">
            <form className="xiAddOrg">
              <h1 className="pb-2 w-100 text-left"> Create an Account </h1>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <label className="form-label">
                    Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name"
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <label className="form-label">
                    Email<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Email"
                    className="form-control"
                    value={email}
                    readOnly
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <label className="form-label">
                    Mobile Number<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Mobile Number"
                    className="form-control"
                    maxLength="10"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                  />
                </div>
                <div className="col-md-6 mb-2" style={{ position: "relative" }}>
                  <label className="form-label">
                    Password<span className="text-danger">*</span>
                  </label>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span className="showPswd">
                    {showPassword ? (
                      <FaEye onClick={() => setShowPassword(false)} />
                    ) : (
                      <FaEyeSlash onClick={() => setShowPassword(true)} />
                    )}
                  </span>
                </div>

                <div className="col-md-12 text-end mt-2 mb-2">
                  <span className="xiaddOrgSignUp">
                    <a className="btn btn-btn1 btn-btn bg-secondary me-2 mb-2">
                      Cancel
                    </a>
                    <a
                      className="btn btn-btn1 btn-btn bg-primary me-2 mb-2"
                      onClick={Signup}
                    >
                      {isloading ? (
                        <img
                          src={Loading}
                          alt="loaderImg"
                          width={20}
                          height={20}
                        ></img>
                      ) : (
                        "Next"
                      )}
                    </a>
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
